module.exports = __webpack_public_path__ + "img/horizontal_4_6_5010.01457430.png";